<p-calendar
  #calendar
  *ngIf="srvCalendarTranslate.pcalendarTranslate"
  [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
  [locale]="srvCalendarTranslate.pcalendarTranslate"
  showIcon="true"
  inputName="formControlName"
  [monthNavigator]="true"
  [yearNavigator]="true"
  [yearRange]="yearRange"
  [defaultDate]="defaultDate"
  [(ngModel)]="defaultValue"
  [placeholder]="srvCalendarTranslate.pcalendarTranslate.placeholderFormat"
  [maxDate]="maxDate"
  [minDate]="minDate"
  (onInput)="dateChangeHandler(calendar, formData, $event)"
  (onSelect)="dateChangeHandler(calendar, formData)"
  (click)="mouseClickHandler($event)"
  (dblclick)="mouseClickHandler($event)"
  [ngClass]="{'date-start-issue': dateStartIssue, 'date-end-issue': dateEndIssue}"
  [disabled]="disabled"
></p-calendar>
<span class="input-error-notification" *ngIf="dateStartIssue">{{ 'common.startDateLimit' | translate }}</span>
<span class="input-error-notification" *ngIf="dateEndIssue">{{ 'common.endDateLimit' | translate }}</span>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-calendar/kv-calendar.component.html